import { createFileRoute } from "@tanstack/react-router";
import { EnEsperaCfdiPage } from "@/features/en-espera-cfdi/components/EnEsperaCfdiPage";

/**
 * Ruta `/contrapagos-pendientes` · P44 FB60 Contrapago · bandeja de
 * solicitudes Autorizadas en espera del CFDI real.
 */
export const Route = createFileRoute("/_authed-tw/contrapagos-pendientes")({
  component: EnEsperaCfdiPage,
});
